import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pizza-size-picker',
  templateUrl: './pizza-size-picker.component.html',
  styleUrls: ['./pizza-size-picker.component.scss']
})
export class PizzaSizePickerComponent implements OnInit {

  @Input() selectedSide:"left"|"full"|"right"|null;
  @Input() disableFullToppingSelection:boolean;
  @Input() disableHalfToppingSelection:boolean;
  @Output() pizzaSideSelected = new EventEmitter();

  constructor() { }

  ngOnInit() {}

  /** Selects the side of the pizza where the topping is supposed to go*/
  selectSide(pizzaSideNumber:"left"|"full"|"right"){
    if(
        (pizzaSideNumber == "full" && !this.disableFullToppingSelection) ||
        (pizzaSideNumber != "full" && !this.disableHalfToppingSelection)
      ){
      this.selectedSide = pizzaSideNumber;
      this.pizzaSideSelected.emit(pizzaSideNumber);
    }
  }

}
